export default __webpack_public_path__ + "static/misc6-63cb6a68191ae6715059c259e79363b7.jpg";